<template>
  <v-app class="layout-auth primary">
    <v-main>
      <v-container class="page-login" fill-height>
        <v-row>
          <v-col>
            <v-card class="pa-3 page-login__card" tile>
              <v-card-title class="mb-5">
                <img
                  class="top-logo"
                  :src="computeLogoIcon"
                  height="50"
                  alt="Turtas"
                />
                <h1 class="primary--text display-1 page-login_title ml-5">
                  {{ appTitle }}
                </h1>
              </v-card-title>
              <v-card-text>
                <el-sistema-info />
                <template v-if="isLocal || isDevelop">
                  <v-form
                    ref="form"
                    class="my-0"
                    lazy-validation
                    v-model="formValid"
                  >
                    <v-row no-gutters align="end">
                      <v-col cols="8">
                        <v-row no-gutters>
                          <v-col cols="12" class="pt-3">
                            <el-text-field
                              append-icon="mdi-account"
                              autocomplete="off"
                              name="login"
                              label="Prisijungimo vardas"
                              type="text"
                              required
                              :rules="formRule.username"
                              v-model="formModel.username"
                            />
                          </v-col>
                          <v-col cols="12">
                            <el-text-field
                              append-icon="mdi-lock"
                              autocomplete="off"
                              name="password"
                              label="Slaptažodis"
                              type="password"
                              :rules="formRule.password"
                              required
                              v-model="formModel.password"
                              v-on:keyup.enter="login"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="4" class="text-right mb-5">
                        <el-button
                          large
                          tile
                          primary
                          @click.native="localLogin"
                          :loading="loading"
                        >
                          Prisijungti
                        </el-button>
                      </v-col>
                    </v-row>
                  </v-form>
                </template>
                <template v-if="!isLocal">
                  <v-row no-gutters>
                    <v-col cols="12" class="text-center my-4">
                      <el-button
                        class="iPasasLogin"
                        primary
                        @click.native="iPasasLogin"
                        :loading="loading"
                      >
                        Prisijungti per iPasas.lt
                      </el-button>
                    </v-col>
                  </v-row>
                </template>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <img
                  :src="computeRCLogo"
                  class="rclogo my-2 mr-4"
                  alt="Registrų centras"
                />
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-footer class="login-footer">
      Darbui su TURTAS naudotinos šios naršyklės: Mozilla Firefox (nuo 88
      versijos), Google Chrome (nuo 91 versijos), Edge (nuo 91 versijos).<br />
      Rekomenduojama ekrano rezoliucija yra nuo 1024x768 iki 1920x1080,
      priartinimas - 100%
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'

export default {
  name: 'PageLogin',
  mixins: [userRole],
  data() {
    return {
      loading: false,
      formValid: false,
      formRule: {
        username: [v => !!v || 'laukas privalomas'],
        password: [v => !!v || 'laukas privalomas'],
      },
      preprodUsername: '',
    }
  },
  computed: {
    ...mapGetters(['userSutikimas', 'appSavitarna', 'ipasasNative']),
    formModel() {
      return {
        username: this.isSavitarna ? 'testsav' : 'test',
        password: 'test',
      }
    },
    prefix() {
      return ''
    },
    computeLogoIcon() {
      return '/static/turtas_icon_trans.png'
    },
    computeRCLogo() {
      return '/static/rclogo.png'
    },
    appTitle() {
      if (this.isTest) {
        return 'Turtas test'
      }
      if (this.isPreprod) {
        return 'Turtas preprod'
      }
      return 'Turtas'
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isDevelop() {
      return process.env.VUE_APP_LOCAL === 'develop'
    },
    isTest() {
      return process.env.VUE_APP_LOCAL === 'test'
    },
    isPreprod() {
      return process.env.VUE_APP_PREPROD === 'true'
    },
    isSavitarna() {
      return this.appSavitarna
    },
    iPasasUrl() {
      return process.env.VUE_APP_IPASAS_URL
    },
  },
  created() {
    this.getPranesimas()
    this.$store.dispatch('ipasasNative', 1)
  },
  methods: {
    getPranesimas() {
      this.$axios
        .get(`sistemos-informavimas`)
        .then(res => {
          this.$store.dispatch(
            'sistemaInfo',
            res.data?.sistemos_informavimas ?? null
          )
        })
        .catch(err => {
          //window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
    },
    localLogin() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$store
          .dispatch('localLogin', this.formModel)
          .then(() => {
            this.$store.dispatch('loadTooltips')
            this.loading = false
            if (!this.userSutikimas) {
              this.$router.push({ name: 'sutikimas' })
              return
            }
            const gautasPranesimas = sessionStorage.getItem('gautasPranesimas')
            if (gautasPranesimas && gautasPranesimas.length > 0) {
              if (this.isSavitarna) {
                this.$router.push({ name: 'pranesimai' })
                return
              }
              if (this.roleRGV) {
                this.$router.push({ name: 'zurnalasSiunciami' })
                return
              }
              this.$router.push({
                name: 'pagrindinis',
              })
              return
            }
            if (this.roleRGV) {
              this.$router.push({ name: 'zurnalasGaunami' })
              return
            }
            if (this.role(['AD_administratorius'])) {
              this.$router.push({ name: 'administravimas' })
              return
            }
            if (!this.roleDT && !this.roleRGV && this.rolePaieska) {
              this.$router.push({ name: 'paieskaTab' })
              return
            }
            this.$router.push({ name: 'home' })
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
    iPasasLogin() {
      this.loading = true
      window.location.href = this.iPasasUrl
    },
    iPasasLoginTest() {
      this.$store
        .dispatch('ipasasLoginTest', { username: this.preprodUsername })
        .then(() => {
          // this.$store.dispatch('loadTooltips')
          // this.$store.dispatch('searchParams', null)
          this.loading = false

          this.$router.push({ name: 'zurnalasGaunami' })
          return
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.page-login {
  &__card {
    max-width: 600px;
    margin: 0 auto;
  }
}
.layout-auth {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
  z-index: 0;
}
.rclogo {
  max-width: 150px;
}

.iPasasLogin {
  width: 50%;
}

.login-footer {
  background: none;
  color: #aeaeae;
  font-size: 0.8rem;
  text-align: end;
  display: inline-block;
}
</style>
